import getTopPicksInfo from "./getTopPicksInfo";

const getNewRequestData = () => {
    let topPicks = window.bf20.topPicks;
    if (window.bf20.previewMode) {
        topPicks = window.bf20.topPicksPreview
    }
    getTopPicksInfo(topPicks);
}

export default getNewRequestData;